import { render, staticRenderFns } from "./BookPage.vue?vue&type=template&id=451795dc&"
import script from "./BookPage.vue?vue&type=script&lang=js&"
export * from "./BookPage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BookPage.vue?vue&type=style&index=0&id=451795dc&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports